

















import { defineComponent, computed } from '@vue/composition-api'

import { IReceipt, ReceiptType } from '@/types/receipt'

import { receiptToRow } from '@/utils/mapper'

type Props = {
  receipts: IReceipt[]
  total: number
  receiptType: ReceiptType
  loading: boolean
}

export default defineComponent({
  name: 'ReceiptsTable',
  props: {
    receipts: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    receiptType: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store

    const headers = [
      { text: 'ID', value: 'id' },
      { text: 'チェーン店名', value: 'chainStoreName' },
      { text: '店舗名', value: 'storeName' },
      { text: 'TEL', value: 'phone' },
      { text: '購入点数', value: 'totalItem', align: 'right' },
      { text: '受取日時', value: 'dateToDisplay' },
      { text: 'リンカーID', value: 'okedByLinkerId' },
      { text: 'リンカー処理日時', value: 'linkerOkedToDisplay' },
    ]
    const items = computed(() =>
      props.receipts.map(r => receiptToRow(r, props.receiptType)),
    )

    const onClickEditButton = async (
      item: Record<string, string | boolean>,
    ) => {
      await store.dispatch('receipt/getReceiptWithReProcess', item.id)
      await store.dispatch('receipt/setReceiptType', props.receiptType)
      context.root.$router.push('/ocr').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    const options = {}

    return { headers, items, onClickEditButton, options }
  },
})
